export const validationMessages = {
  required: {
    string: "Este campo es obligatorio",
    number: "Este campo es obligatorio",
    boolean: "Este campo es obligatorio",
  },
  min: {
    string: (min: number) => `Debe tener al menos ${min} carácter${min === 1 ? '' : 'es'}`,
    number: (min: number) => `El valor mínimo es ${min}`,
  },
  max: {
    string: (max: number) => `No puede tener más de ${max} caracteres`,
    number: (max: number) => `El valor máximo es ${max}`,
  },
  email: "Debe ser un email válido",
  url: "Debe ser una URL válida",
  phone: "Debe ser un número de teléfono válido",
  cuit: "Debe ser un CUIT válido",
  date: {
    invalid: "Debe ser una fecha válida",
    min: (date: string) => `La fecha debe ser posterior a ${date}`,
    max: (date: string) => `La fecha debe ser anterior a ${date}`,
  },
  number: {
    integer: "Debe ser un número entero",
    positive: "Debe ser un número positivo",
    negative: "Debe ser un número negativo",
  },
  boolean: {
    true: "Debe estar marcado",
    false: "No debe estar marcado",
  },
} as const; 